import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className, y = 36, ...rest }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.8, delay, ease: EASE }}
        className={className}
        {...rest}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className }) => (
    <span className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.95, delay, ease: EASE }}
            className={`block will-change-transform ${className || ""}`}
        >
            {children}
        </motion.span>
    </span>
);

export const SectionHead = ({ tag, title, sub, dark = false, align = "left" }) => (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
        <FadeUp>
            <p className="section-tag" data-testid={`tag-${tag?.replace(/\W+/g, "-").toLowerCase()}`}>{tag}</p>
        </FadeUp>
        <FadeUp delay={0.08}>
            <h2 className={`mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.06] ${dark ? "text-white" : "text-ink"}`}>
                {title}
            </h2>
        </FadeUp>
        {sub && (
            <FadeUp delay={0.16}>
                <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-mist" : "text-smoke"}`}>{sub}</p>
            </FadeUp>
        )}
    </div>
);
